var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper-prepayment" }, [
    _c("section", { ref: "section-topbar", staticClass: "section-topbar" }, [
      _c("div", { staticClass: "back" }, [
        _c("button", { on: { click: _vm.handleClickBack } }, [
          _c("i", { staticClass: "fas fa-angle-left" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-total" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.$t("apps.pos.message.currentsale", {
                number: _vm.ordersCount
              })
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fake" }, [_vm._v("\n       \n    ")])
    ]),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass: "section-order",
        style: [{ height: _vm.sectionOrderHeight + "px" }]
      },
      [
        _c("orderlist-view", {
          staticClass: "order-list",
          attrs: { disabled: "false" },
          on: { onDeleteOrder: _vm.handleOnDeleteOrder }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { ref: "section-checkout", staticClass: "section-checkout" },
      [
        _c("optionsbutton-view", {
          staticClass: "btn-options",
          on: { onClearOrder: _vm.handleClearOrder }
        }),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("totalprice-view", {
              staticClass: "total-price",
              staticStyle: { "border-top": "solid 1px #F2F2F2" },
              attrs: { disabled: "true" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-btn" },
          [
            _c("TotalPriceButton", {
              staticClass: "btn-submit-order",
              attrs: { disabled: "false" }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27e56707", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e56707","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/include/PrePayment.vue
// module id = null
// module chunks = 